import * as React from "react";
import { Company } from "../../../../domain/model/company";
import { Project } from "../../../../domain/model/project";

import Pagination from "../../../common/molecular/pagination/pagination";

import { TCompanyWithProjectID } from "../../../../domain/repository/company_repository";
import { TPagination } from "../../../type/common";
import styled from "styled-components";
import ProjectCustomerCard from "../../../common/organism/card/project_customer_card";
import { ConstBreakPoint } from "../../../../config/styles_const/styles_const";

interface IProps {
  projects: Project[];
  companiesWithProjectID: TCompanyWithProjectID[];
  isLoading: boolean;
  paginationPrams: TPagination;
}

export const CustomerProjectsMain: React.FC<IProps> = (props) => {
  const { projects, companiesWithProjectID, paginationPrams } = props;

  // projectId: Companyの連想配列を作成し、Projectから連携させる。
  const hashCompany: { [projectId: string]: Company } = {};
  for (const item of companiesWithProjectID) {
    hashCompany[item.projectID] = item.company;
  }

  return (
    <React.Fragment>
      <ProjectCardsWrapper>
        {projects.map((project: Project, index: number) => {
          const projectId: string = project.id;
          const company: Company | undefined = hashCompany[projectId];
          if (!company) {
            return null;
          }
          return (
            <ProjectCardWrapper key={projectId}>
              <ProjectCustomerCard
                company={company}
                project={project}
                user={null}
                contract={null}
              />
            </ProjectCardWrapper>
          );
        })}
      </ProjectCardsWrapper>
      <Pagination paginationPrams={paginationPrams} />
    </React.Fragment>
  );
};

export default CustomerProjectsMain;

const ProjectCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;

const ProjectCardWrapper = styled.div`
    width: 100%
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin:0 15px 30px 0;
        width:calc(33.3333333% - 30px / 3);
        &:nth-child(3n){
            margin-right:0;
        }
    }

`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects_main.tsx